export default __webpack_public_path__ + "static/media/1.bb5cacda.png";